export default {
  'show-list': 'List',
  'show-map': 'Map',
  'details': 'Details',
  'route-link': 'Route',
  'route-link.detail': 'Find route',
  'map': 'Map',
  'has-boxes': 'Hermes packaging sales',
  'acceptsSuitcases': 'Luggage drop-off',
  'back': 'back',

  'shoplist.info': {
    __html: 'Please enter a postcode, town/city and/or street name above, around which a search should be performed.'
  },

  'shoplist.no-reroute-shops': 'No selectable ParcelShops were found near the location searched for.',

  'business-hours.unknown': 'The business hours of this ParcelShop are not known.',
  'business-hours.closed': 'Closed',

  'search': 'Search',
  'search.input-placeholder': 'Enter address, postcode or town/city',
  'search-criteria': 'Search criteria',
  'search.toggle-details': 'Detailed search',
  'search-detail.intro': 'The ParcelShops displayed can be narrowed down according to the following criteria:',
  'search-detail.luggage.label': 'Luggage drop-off',
  'search-detail.boxes.label': 'Hermes packaging sales',
  'search-detail.apply': 'Apply filters',
  'search-detail.close': 'Close',

  'error.no-shops': {
    __html: 'No ParcelShops were found near the location searched for.'
  },

  'error.address-resolve-failed': 'The address entered could not be found.',
  'error.position-resolve-failed': 'The location entered could not be found.',

  'days.short.MON': 'Mon.',
  'days.short.TUE': 'Tue.',
  'days.short.WED': 'Wed.',
  'days.short.THU': 'Thur.',
  'days.short.FRI': 'Fri.',
  'days.short.SAT': 'Sat.',
  'days.short.SUN': 'Sun.',
  'days.full.MON': 'Monday',
  'days.full.TUE': 'Tuesday',
  'days.full.WED': 'Wednesday',
  'days.full.THU': 'Thursday',
  'days.full.FRI': 'Friday',
  'days.full.SAT': 'Saturday',
  'days.full.SUN': 'Sunday',
  'days.today': 'Today',
  'days.tomorrow': 'Tomorrow',

  'time.preposition.UNTIL': 'until',
  'time.preposition.BEFORE': 'before',

  //paketParcelLock
  'search.paketParcelLock.note': 'Please note: ',
  'search.paketParcelLock.link-text': 'how it works',
  'search.paketParcelLock.link-url': 'https://www.myhermes.de/service/paketstation/',

  //paketParcelLock
  'details.benefits.paketParcelLock.list-1': 'Sending of parcels',
  'details.benefits.paketParcelLock.list-2': 'Online shop returns',
  'details.benefits.paketParcelLock.list-3': 'Send parcels fast and easy',
  'details.benefits.paketParcelLock.link-wrapper-text': 'For more Information please see ',
  'details.benefits.paketParcelLock.link-text': 'www.hamburgbox.de/faq',
  'details.benefits.paketParcelLock.link-url': 'http://www.hamburgbox.de/faq',

  //paketParcelLock
  'details.hint.paketParcelLock.headline': 'Important note:',
  'details.hint.paketParcelLock.copy': 'To be able to use this parcel station, a TAN is required to pick up the shipment.',
  'details.hint.paketParcelLock.link-text': ' How it works',
  'details.hint.paketParcelLock.link-url': 'https://www.myhermes.de/service/paketstation/',

  // Media markkt
  'details.hint.parcel-shop.media-markt.copy': 'Only personal parcels with a label paid for online (via myHermes.de or the Hermes app) can be handed in at this Hermes ParcelShop.',

  //paketParcelLock
  'callback-button.paketParcelLock.text': 'Select Paketstation',

  //paketParcelLock
  'details.title.paketParcelLock': 'Paketstation',

  'details.title': 'Hermes ParcelShops',
  'details.opening-hours': 'Opening hours',
  'details.opening-hours-today': 'Opening hours today',
  'details.parcelShopNumber': 'ParcelShop ID',

  'details.benefits.shipping': 'Sending of parcels',
  'details.benefits.paketfuxx': 'Delivery to neighbour',
  'details.benefits.redirect': 'Alternative delivery address',
  'details.benefits.pickup': 'Collection with authorisation',
  'details.benefits.retours': 'Online shop returns',

  'details.on-holiday.note': 'Please note:',
  'details.on-holiday': 'Our ParcelShop is closed %from %to.',
  'details.on-holiday.short': 'Holiday: %from – %to',
  'services': 'Services',
  'callback-button.text': 'Select ParcelShop',
  'callback-button.unavailable': 'This ParcelShop can unfortunately not be selected as a PreferredParcelShop.',

  'filter.luggage': 'Luggage drop-off',
  'filter.boxes': 'Hermes packaging',
  'filter.time': 'Open $day %time',

  'time-filter.closed': 'Opens at ',
  'time-filter.opened': 'Open until ',
  'time-filter.from': ' and from ',
  'time-filter.openedNextDay': 'Opens on ',
  'time-filter.at': 'at',
  'time-filter.openedFilter': 'Open ',

  'time-filter.openToday': 'Open today: ',
  'time-filter.clock': ' o’clock',

  'social-buttons.facebook': 'share',
  'social-buttons.twitter': 'tweet',
  'social-buttons.whatsapp': 'share',
  'social-buttons.email': 'email',
  'social-buttons.print': 'print',

  'shop-list.title': 'ParcelShops in the vicinity',
  'widget.headline': 'Search for a ParcelShop',
  'widget.input-placeholder': 'Address, postcode, town/city',
  'widget.option-button': 'Other options',
  'widget.submit-button': 'Search',
  'widget.open-on': 'Open on',

  'legal': 'Imprint',
  'security': 'Security Advice',
  'privacy': 'Data Protection',
  'cookies': 'Cookies',

  'legal.url': 'https://www.hermesworld.com/int/credits/',
  'security.url': 'https://www.hermesworld.com/int/security-advice/',
  'privacy.url': 'https://www.hermesworld.com/int/data-protection/',
  'cookies.url': '#uc-corner-modal-show',

  'cookie.text': 'This website uses cookies to analyse our traffic.',
  'cookie.button-text': 'Ok',
  'cookie.link-text': 'Learn more',
  'cookie.link-url': 'https://www.hermesworld.com/int/data-protection/',

  //UserCentrics Cookie Consent
  'usercentrics.info': 'Die Anzeige von PaketShops in der Nähe basiert auf Google Maps. Mit dem Klick auf "Karte aktivieren" stimme ich der Datenfreigabe an Google Maps zu.',
  'usercentrics.button': 'Karte aktivieren',
  'usercentrics.privacy-text': 'Datenschutz',
  'usercentrics.privacy-url': 'https://www.myhermes.de/datenschutz/',
  'usercentrics.impressum-text': 'Impressum',
  'usercentrics.impressum-url': 'https://www.myhermes.de/impressum/'
};
